/**
 * Regras da leitura pública (antes do login) no banco externo.
 *
 * Algumas telas precisam de dados ANTES de existir um usuário logado (a tela
 * de entrada lê a marca e os parâmetros do aplicativo). Para isso existe uma
 * consulta pública, limitada a leituras simples nas tabelas/funções abaixo.
 */

/** Tabelas e funções liberadas para leitura sem login. */
export const LEITURA_PUBLICA = ["app_params", "app_branding", "marca"] as const;

const PROIBIDO = /\b(insert|update|delete|drop|alter|create|grant|revoke|truncate|copy|do|call)\b/i;

/** Confere se o SQL é uma leitura simples e permitida sem login. */
export function leituraPublicaPermitida(sql: string): boolean {
  const limpo = sql.trim().replace(/;\s*$/, "");
  if (limpo.includes(";") || limpo.includes("--") || limpo.includes("/*")) return false;
  if (!/^select\b/i.test(limpo)) return false;
  if (PROIBIDO.test(limpo)) return false;

  const nomes = [...limpo.matchAll(/\b(?:from|join)\s+([a-z0-9_."]+)/gi)].map((m) =>
    (m[1] ?? "")
      .replace(/"/g, "")
      .replace(/^public\./i, "")
      .toLowerCase(),
  );
  if (nomes.length === 0) return false;
  return nomes.every((n) => (LEITURA_PUBLICA as readonly string[]).includes(n));
}
